'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index$1 = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Content_web_styles = require('../Content/Content.web.styles.cjs');
var Item_web_styles = require('../Item/Item.web.styles.cjs');

/**
 * Subcomponent of DropdownMenu. This component is used to create a SubMenu within a DropdownMenu.
 *
 * @scope: Web
 */ const SubMenu = ({ title, type = "default", icon, children, ...rest })=>{
    const itemStyles = [
        Item_web_styles.item,
        type === "danger" && Item_web_styles.variants[type]
    ];
    const renderIcon = ()=>{
        if (icon) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Item_web_styles.iconContainer,
                children: /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                    icon: icon
                })
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            css: Item_web_styles.iconContainer
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs(index.Sub, {
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs(index.SubTrigger, {
                css: itemStyles,
                ...rest,
                children: [
                    renderIcon(),
                    /*#__PURE__*/ jsxRuntime.jsxs("div", {
                        css: Item_web_styles.subMenuTrigger,
                        children: [
                            /*#__PURE__*/ jsxRuntime.jsx("div", {
                                css: [
                                    Item_web_styles.text.base,
                                    Item_web_styles.text.submenu
                                ],
                                children: title
                            }),
                            /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                                icon: index$1.faChevronRight
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
                children: /*#__PURE__*/ jsxRuntime.jsx(index.SubContent, {
                    sideOffset: 6,
                    css: Content_web_styles.content,
                    children: children
                })
            })
        ]
    });
};

exports.SubMenu = SubMenu;
//# sourceMappingURL=SubMenu.web.cjs.map
